import { render, staticRenderFns } from "./PrevidenzaIntegrativa.vue?vue&type=template&id=0c933362&scoped=true"
import script from "./PrevidenzaIntegrativa.vue?vue&type=script&lang=js"
export * from "./PrevidenzaIntegrativa.vue?vue&type=script&lang=js"
import style0 from "./PrevidenzaIntegrativa.vue?vue&type=style&index=0&id=0c933362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c933362",
  null
  
)

export default component.exports